import React from 'react'

const ForLeaders = ({ userData }) => {
  return <div></div>
}

export default ForLeaders
